import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { UserService } from '../../user/user.service';

const SHOPS_URL = '/settings/shops';
const EXEMPT_URLS = [
    SHOPS_URL,
    '/settings/general/account',
    '/settings/general/security',
    '/settings/credits',
    '/settings/general/finance',
];

export const ShopGuard: CanActivateFn | CanActivateChildFn = (
    route,
    state
) => {
    const router: Router = inject(Router);
    const userService = inject(UserService);

    return userService.getShops().pipe(
        map((shops) =>
            shops.length ||
            userService.isEmployee ||
            EXEMPT_URLS.some((url) => state.url.startsWith(url))
                ? true
                : router.parseUrl(SHOPS_URL)
        ),
        catchError(() => of(true))
    );
};
